import type { StatusTone } from '../contracts/common';
import type { BillingCycle, ServiceKind, ServiceStatus } from '../contracts/services';

export const SERVICE_KIND_LABELS: Record<ServiceKind, string> = {
  maintenance: 'Utrzymanie',
  consulting: 'Konsultacje',
  hours_package: 'Pakiet godzin',
  other: 'Inna',
};

export const SERVICE_STATUS_LABELS: Record<ServiceStatus, string> = {
  active: 'Aktywna',
  paused: 'Wstrzymana',
  ended: 'Zakończona',
};

export const SERVICE_STATUS_TONES: Record<ServiceStatus, StatusTone> = {
  active: 'success',
  paused: 'warning',
  ended: 'neutral',
};

/** Cykl w formularzu (Figma „Dodaj zasób”: „Co rok”). */
export const BILLING_CYCLE_LABELS: Record<BillingCycle, string> = {
  year: 'Co rok',
  quarter: 'Co kwartał',
  month: 'Co miesiąc',
  other: 'Inny',
  none: 'Jednorazowo',
};

/** Przyrostek kwoty, np. „1 990 zł / rok”, „490 zł / mies.” (pusty dla `none` i `other`). */
export const BILLING_CYCLE_SUFFIX: Record<BillingCycle, string> = {
  year: '/ rok',
  quarter: '/ kw.',
  month: '/ mies.',
  other: '',
  none: '',
};
